module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG1007-a8c2b5d5d776256abde05c52036072a3.png";